export default {
  'admin': 'Administrateur',
  'users': 'Utilisateurs',
  'assets': 'Les Atouts',
};